import style from "./styles/SalaryCard.module.css";
import {Tag} from "antd";
import React from "react";


const MinMaxSalary = ({max_salary_month, min_salary_month}) => {
    return (
        <div className={style.cardFooter}>
            {max_salary_month.status && (
                <div className={style.highlight}>
                    <div>
                        <Tag color="green" className={style.highlightTag}>
                            Макс
                        </Tag>
                        <span style={{fontWeight: 'bold', marginLeft: '5px', fontSize: '12px'}}>
                            {max_salary_month.amount}
                        </span>
                    </div>
                    <div>
                        <span style={{marginLeft: '20px', color: '#6e6e6e'}}>
                            {max_salary_month.month}
                        </span>
                    </div>

                </div>
            )}

            {min_salary_month.status && (
                <div className={style.highlight}>
                    <div>
                        <Tag color="volcano" className={style.highlightTag}>
                            Мин
                        </Tag>
                        <span style={{fontWeight: 'bold', marginLeft: '5px', fontSize: '12px'}}>
                {min_salary_month.amount}
                </span>
                    </div>
                    <div>
                <span style={{marginLeft: '20px', color: '#6e6e6e'}}>
                {min_salary_month.month}
                </span>
                    </div>
                </div>
            )}
        </div>
    )
}

export default MinMaxSalary